import { Icon } from "common/Icon";
import { SingleLineEditor } from "common/SingleLineEditor";
import { rideReportSelectors } from "data/resources/rideReports";
import { getReportCover } from "lib/getReportCover";
import { featureNames, useFormatMessage } from "lib/localization";
import moment from "moment";
import React, { Fragment } from "react";
import { FormattedMessage as T } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { rrMessages } from "../../intlMessages";
import styles from "./Footer.scss";

const RelatedCard = ({ report, journalArticle }) => (
  <div className={styles.RelatedCard}>
    <Link
      to={`/${journalArticle ? "journal" : "ride_reports"}/${report.slug}`}
      className={styles.gutterHack}
      style={{ backgroundImage: `url(${getReportCover(report)})` }}
    >
      <div className={styles.onTop}>
        <h3>{report.title}</h3>
        <p>
          {report.subtitle && (
            <SingleLineEditor defaultValue={report.subtitle} textAlignment="left" readOnly lineClamp type="subtitle" />
          )}
        </p>
      </div>
    </Link>
  </div>
);

// just used for related news right now
const _FlatRelated = ({ report, v3Report }) => {
  const v3 = v3Report(report.slug);
  let link;
  if (v3 && v3.authorUrl) {
    link = (
      <Fragment>
        <Icon i="md-open" style={{ paddingRight: "10px" }} />
        <Link href={v3.authorUrl} target="_blank" className={styles.flatTitle}>
          {report.title}
        </Link>
      </Fragment>
    );
  } else {
    link = (
      <Link to={`/news/${report.slug}`} className={styles.flatTitle}>
        {report.title}
      </Link>
    );
  }

  return (
    <div className={styles.flat}>
      {link}
      <div className={styles.flatPublished}>{moment(report.publishedAt).format("MMMM DD, YYYY")}</div>
    </div>
  );
};

export const Footer = ({ report, relatedReports, journalArticle, newsArticle }) => {
  const fm = useFormatMessage();
  let link;
  if (journalArticle) {
    link = (
      <Link to={"/journal"} className={styles.userLink}>
        {fm(rrMessages.theJournal)}
      </Link>
    );
  } else if (newsArticle) {
    link = fm(rrMessages.news);
  } else {
    link = (
      <Link to={`/ride_reports/user/${report.user.id}`} className={styles.userLink}>
        {report.user.name}
      </Link>
    );
  }

  return (
    <div className={styles.Footer}>
      <hr />
      <div className={styles.related}>
        {relatedReports && relatedReports.size > 0 && (
          <h2 className={styles.heading}>
            {fm(newsArticle ? featureNames.more : rrMessages.moreStories)} {link}:
          </h2>
        )}
        {relatedReports && relatedReports.size > 0 && (
          <div className={styles.relatedCardContainer}>
            {relatedReports.map((r) =>
              newsArticle ? (
                <FlatRelated key={r.id} report={r} />
              ) : (
                <RelatedCard key={r.id} report={r} journalArticle={journalArticle} />
              )
            )}
          </div>
        )}
      </div>
      {!(journalArticle || newsArticle) && (
        <p className={styles.plug}>
          <T
            id="ShowPageFooter.plug"
            defaultMessage="This ride report was made with Ride with GPS. Share your own stories with a free account at <a>ridewithgps.com</a>."
            values={{ a: (...chunks) => <a href="/">{chunks}</a> }}
          />
        </p>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  v3Report: (slug) => rideReportSelectors.bySlug(state, slug),
});

const FlatRelated = connect(mapStateToProps, null)(_FlatRelated);
